import { type FilterValues } from "components/filters/FilterContext";
import { mapKeywordFilterToInstruction, mapResponseToKeywordFilter, mapResponseToVisibilityFilter, mapVisibilityFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedExternalCalendarInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    isActive: mapVisibilityFilterToInstruction(filter.visible),
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListExternalCalendarFilters
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response?.keyword),
  visible: mapResponseToVisibilityFilter(response?.isActive || "noFilter")
});